module.exports = __webpack_public_path__ + "img/chinesecompany91.aa3f9cc7.png";